// Owner: account-settings (plan §3.2, §9.3). Settings › Notification defaults.
import { createFileRoute } from '@tanstack/react-router';
import { NotificationDefaultsPage } from '../../../features/account/NotificationDefaultsPage';

export const Route = createFileRoute('/_settings/settings/notifications')({
  component: NotificationDefaultsPage,
});
